export const streamKeys = [
    "symbol",
    "curPrice",
    "changePrice",
    "changePercentage",
    "updatedTime",
    "marketStatus",
    "oiChange",
    "oiChangePercentage",
    "volume",
    "openInterest",
    "futurePrice",
    "spotPrice",
    "bid",
    "ask",
    "iv",
    "high",
    "low",
    "open",
    "close",
    "rollOver",
    "rollOverCost",
    "rollOverCostPercentage",
    "totalTradedValue",
    "bidQty",
    "askQty",
    "avgTradedPrice", //25
];
class QuoteResponseMappper {
    formatResponse(streamRes, listKey, cbs) {
        try {
            const ResData = JSON.parse(streamRes).response;
            let formatData = {};
            listKey.forEach((key) => {
                formatData[key] = this.getValueKey(ResData.data, key);
            });
            if (ResData.streaming_type === cbs.streaming_type
            //&&
            // listKey.toString() === cbs.streamKey.toString() &&
            // cbs.symbols.includes(formatData.symbol)
            ) {
                cbs.listener(formatData);
            }
        }
        catch (error) {
            console.log("Stream Response Format error", error);
        }
    }
    getValueKey(data, key) {
        switch (key) {
            case streamKeys[0]:
                return data["sym"];
            case streamKeys[1]:
                return data["ltp"];
            case streamKeys[2]:
                return data["chg"];
            case streamKeys[3]:
                return data["chgp"];
            case streamKeys[4]:
                return data["lut"];
            case streamKeys[5]:
                return data["mO"] === "0" ? "Open" : "Closed";
            case streamKeys[6]:
                return data["oiChg"];
            case streamKeys[7]:
                return data["oiChgp"];
            case streamKeys[8]:
                return data["vol"];
            case streamKeys[9]:
                return data["oI"];
            case streamKeys[10]:
                return data["futPrc"];
            case streamKeys[11]:
                return data["spotPrc"];
            case streamKeys[12]:
                return data["bPr"];
            case streamKeys[13]:
                return data["aPr"];
            case streamKeys[14]:
                return data["ltpivfut"];
            case streamKeys[15]:
                return data["h"];
            case streamKeys[16]:
                return data["l"];
            case streamKeys[17]:
                return data["o"];
            case streamKeys[18]:
                return data["c"];
            case streamKeys[19]:
                return data["rocost"];
            case streamKeys[20]:
                return data["rocostp"];
            case streamKeys[21]:
                return data["roperc"];
            case streamKeys[22]:
                return data["ntTrdVal"];
            case streamKeys[23]:
                return data["bSz"];
            case streamKeys[24]:
                return data["aSz"];
            case streamKeys[25]:
                return data["avgPrc"];
            default:
        }
    }
}
export default QuoteResponseMappper;
